//core
import React, { useRef } from "react";
import { makeStyles, useTheme } from "@mui/styles";
import { Box, Tooltip } from "@mui/material";

//hooks
import useDimensions from "../../../../../customHooks/useDimensions";

//icons
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import HelpIcon from '@mui/icons-material/Help';
import {
  TelegramIcon,
  ViberIcon,
  TeamsIcon,
} from "../../../../UI/Icons";
import {Theme} from "@mui/material/styles/createTheme";


const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
    color: 'inherit',
  },
  text: {
    whiteSpace: 'nowrap',
    color: 'inherit',
    '& a': {
      color: 'var(--text-primary)',
      maxWidth: 140,
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis',
    },
    '& span': {
      maxWidth: 160,
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis',
    },
  },
  textTooltip: {
    color: 'white',
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    '& a': {
      color: 'white',
      maxWidth: 'none',
      overflow: 'visible',
      textOverflow: 'unset',
      whiteSpace: 'normal',
      wordBreak: 'break-all',
    },
    '& span': {
      color: 'white',
      maxWidth: 'none',
      overflow: 'visible',
      textOverflow: 'unset',
      whiteSpace: 'normal',
      wordBreak: 'break-all',
    },
  },
  icon: {
    width: 16,
    height: 16,
    color: theme.palette.action.active,
    '& svg': {
      width: 16,
      height: 16,
    }
  },
  iconTooltip: {
    width: 16,
    height: 16,
    color: 'white',
    '& svg': {
      width: 16,
      height: 16,
    }
  },
  wrapper: {
    width: "max-content",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

interface IContact {
  type: string;
  value: string;
  className?: string;
  hideOtherTooltip?: boolean;
  isTooltipContent?: boolean;
}

const Contact: React.FC<IContact> = ({
  type,
  value,
  className = '',
  hideOtherTooltip = false,
  isTooltipContent = false,
}): JSX.Element => {
  const theme: Theme = useTheme();
  const styles = useStyles();
  const wrapperRef: any = useRef(null);
  const size = useDimensions(wrapperRef);

  const icon =
    type === 'telegram'
      ? <TelegramIcon width={16} height={16} />
      : type === 'teams'
        ? <TeamsIcon width={16} height={16} />
        : type === 'whatsapp'
          ? <WhatsAppIcon width={16} height={16} />
          : type === 'viber'
            ? <ViberIcon width={16} height={16} />
            : <HelpIcon width={16} height={16} />;

  return (
    <>
      <Box ref={wrapperRef} className={styles.wrapper}
           sx={{ opacity: 0, visibility: "hidden", position: "absolute" }}
      >
        {value ? value : '—'}
      </Box>
      <Box className={styles.block}>
        <span className={`${isTooltipContent ? styles.textTooltip : styles.text} ${!!className ? className : ''}`}>
          {type === 'telegram' && <a href={`https://t.me/${value}`} target="_blank">{ value ? value : '—' }</a>}
	        {type === 'teams' && <a href={`https://teams.microsoft.com/l/chat/0/0?users=${value}`}>{ value ? value : '—' }</a>}
          {type === 'whatsapp' && <a href={`https://wa.me/${value}`}>{ value ? value : '—' }</a>}
          {type === 'viber' && <span>{value ? value : '—'}</span>}

          {type === 'other' && (
            <>
              {(size.width >= 160) ? (
                <>
                  {hideOtherTooltip ? <>
                    <span>{value ? value : '—'}</span>
                  </> : <>
                    <Tooltip title={value ? value : '—'}>
                      <span>{value ? value : '—'}</span>
                    </Tooltip>
                  </>}
                </>
              ) : (
                <span>{value ? value : '—'}</span>
              )}
            </>
          )}
        </span>
        <span className={isTooltipContent ? styles.iconTooltip : styles.icon}>
          { icon }
        </span>
      </Box>
    </>
  );
};

export default Contact;
